// Сгенерировано gen-mdi-icons.mjs — не редактировать вручную.
// Обновить после добавления новой иконки mdi-*: node gen-mdi-icons.mjs
import {
    mdiAlertCircle,
    mdiAppleKeyboardCommand,
    mdiAppleKeyboardControl,
    mdiAppleKeyboardOption,
    mdiAppleKeyboardShift,
    mdiArrowDown,
    mdiArrowLeft,
    mdiArrowRight,
    mdiArrowUp,
    mdiBackspace,
    mdiCached,
    mdiCalendar,
    mdiCheck,
    mdiCheckCircle,
    mdiCheckboxBlankOutline,
    mdiCheckboxMarked,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiChevronUp,
    mdiCircle,
    mdiClose,
    mdiCloseCircle,
    mdiCloudUpload,
    mdiEyedropper,
    mdiFullscreen,
    mdiFullscreenExit,
    mdiInformation,
    mdiInformationOutline,
    mdiKeyboardReturn,
    mdiKeyboardSpace,
    mdiMagnify,
    mdiMenu,
    mdiMenuDown,
    mdiMenuRight,
    mdiMinus,
    mdiMinusBox,
    mdiPageFirst,
    mdiPageLast,
    mdiPalette,
    mdiPaperclip,
    mdiPause,
    mdiPencil,
    mdiPlay,
    mdiPlus,
    mdiRadioboxBlank,
    mdiRadioboxMarked,
    mdiShare,
    mdiStar,
    mdiStarHalfFull,
    mdiStarOutline,
    mdiUnfoldMoreHorizontal,
    mdiVolumeHigh,
    mdiVolumeLow,
    mdiVolumeMedium,
    mdiVolumeVariantOff,
} from '@mdi/js'

export const mdiPaths: Record<string, string> = {
    'mdi-alert-circle': mdiAlertCircle,
    'mdi-apple-keyboard-command': mdiAppleKeyboardCommand,
    'mdi-apple-keyboard-control': mdiAppleKeyboardControl,
    'mdi-apple-keyboard-option': mdiAppleKeyboardOption,
    'mdi-apple-keyboard-shift': mdiAppleKeyboardShift,
    'mdi-arrow-down': mdiArrowDown,
    'mdi-arrow-left': mdiArrowLeft,
    'mdi-arrow-right': mdiArrowRight,
    'mdi-arrow-up': mdiArrowUp,
    'mdi-backspace': mdiBackspace,
    'mdi-cached': mdiCached,
    'mdi-calendar': mdiCalendar,
    'mdi-check': mdiCheck,
    'mdi-check-circle': mdiCheckCircle,
    'mdi-checkbox-blank-outline': mdiCheckboxBlankOutline,
    'mdi-checkbox-marked': mdiCheckboxMarked,
    'mdi-chevron-down': mdiChevronDown,
    'mdi-chevron-left': mdiChevronLeft,
    'mdi-chevron-right': mdiChevronRight,
    'mdi-chevron-up': mdiChevronUp,
    'mdi-circle': mdiCircle,
    'mdi-close': mdiClose,
    'mdi-close-circle': mdiCloseCircle,
    'mdi-cloud-upload': mdiCloudUpload,
    'mdi-eyedropper': mdiEyedropper,
    'mdi-fullscreen': mdiFullscreen,
    'mdi-fullscreen-exit': mdiFullscreenExit,
    'mdi-information': mdiInformation,
    'mdi-information-outline': mdiInformationOutline,
    'mdi-keyboard-return': mdiKeyboardReturn,
    'mdi-keyboard-space': mdiKeyboardSpace,
    'mdi-magnify': mdiMagnify,
    'mdi-menu': mdiMenu,
    'mdi-menu-down': mdiMenuDown,
    'mdi-menu-right': mdiMenuRight,
    'mdi-minus': mdiMinus,
    'mdi-minus-box': mdiMinusBox,
    'mdi-page-first': mdiPageFirst,
    'mdi-page-last': mdiPageLast,
    'mdi-palette': mdiPalette,
    'mdi-paperclip': mdiPaperclip,
    'mdi-pause': mdiPause,
    'mdi-pencil': mdiPencil,
    'mdi-play': mdiPlay,
    'mdi-plus': mdiPlus,
    'mdi-radiobox-blank': mdiRadioboxBlank,
    'mdi-radiobox-marked': mdiRadioboxMarked,
    'mdi-share': mdiShare,
    'mdi-star': mdiStar,
    'mdi-star-half-full': mdiStarHalfFull,
    'mdi-star-outline': mdiStarOutline,
    'mdi-unfold-more-horizontal': mdiUnfoldMoreHorizontal,
    'mdi-volume-high': mdiVolumeHigh,
    'mdi-volume-low': mdiVolumeLow,
    'mdi-volume-medium': mdiVolumeMedium,
    'mdi-volume-variant-off': mdiVolumeVariantOff,
}
